import { useCallback, useContext } from 'react';
import DashboardsContext from '../../../../../contexts/DashboardsContext';
import cardTypeCheckers from '../../../../../types/cardTypeCheckers';

const useFindDashboardByGadgetId = () => {
  const { allDashboards } = useContext(DashboardsContext);
  const findDashboardByGadgetId = useCallback(
    (gadgetId: string): DashboardType | undefined => {
      return allDashboards.find((d) => {
        return d.canvas.cards.find((c) => {
          if (cardTypeCheckers.isDashboardGadget(c)) {
            return c.content.dashboardGadgetId === gadgetId;
          } else if (cardTypeCheckers.isMetricList(c)) {
            return c.content.metricListId === gadgetId;
          }
          return undefined;
        });
      });
    },
    [allDashboards],
  );

  return findDashboardByGadgetId;
};

export default useFindDashboardByGadgetId;
